import { Body } from './Body'
import { Chart } from './Chart'
import { Container } from './Container'
import { Disclaimer } from './Disclaimer'
import { Heading } from './Heading'
import { IconChart } from './IconChart'

export default Object.assign(Container, {
  Disclaimer,
  Heading,
  Body,
  Chart,
  IconChart,
})
